import React from 'react'
import './claim-form.scss'
import { Constants, ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import Loading from '../common/loading/loading'
import Urls from '../../apis/url'
import httpClient from '../../apis/http-client'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import Dropdown from '../common/dropdown-v2/dropdown'
import CommonApi from '../../apis/common'
import CommonUtils from '../../utility/common-utilities'
import CryptoJS from 'crypto-js'

const transferToData = [
  {
    title: 'My Own',
    value: 'My Own'
  },
  {
    title: 'My Father',
    value: 'My Father'
  },
  {
    title: 'My Mother',
    value: 'My Mother'
  },
  {
    title: 'Others',
    value: 'Others'
  }
]
class ClaimForm extends React.Component {
  state = {
    loading: false,
    homeworkDetails: {
      studentCount: 0
    },
    isSuccess: false
  }

  countryCodeHash = {}

  constructor (props) {
    super(props)
    this.state.discountId = props.match.params.id
  }

  componentDidMount () {
    this.getDiscountDetails()
    this.getCountryCodes()
  }

  getDiscountDetails = _ => {
    const { discountId } = this.state
    const payload = {
      _id: discountId
    }
    CommonApi.discountDetails(payload)
      .then(data => {
        if (data && data.user) {
          this.setState({
            discountDetails: data,
            discountError: false,
            email: data.user?.email || '',
            name: data.user?.name || '',
            city: data.user?.city || ''
          })
        } else {
          this.setState({
            discountError: true
          })
        }
      })
      .catch(err => {
        this.setState({
          discountError: true
        })
      })
  }

  copyLink = _ => {
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)

    dummy.value = 'www.countingwell.com/sccode/33523'
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  getCountryCodes (payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropDownData = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropDownData })
        }
      })
      .catch(err => {})
  }

  buildCountryCodeDropdown (list = []) {
    let countryCodeDropdown = []
    let localHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!localHash[item.dialCode]) {
        this.countryCodeHash[item.dialCode] = item
        localHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          addOn: item.name,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: this.countryCodeHash })
    return countryCodeDropdown
  }

  onCountryCodeSearch (value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  validatePayload = _ => {
    this.setState({
      isValidForm: false
    })
    let motherCountryCodeDetail = this.state.hashedCountryCode[
      this.state.motherCountryCode
    ]
    let validateMotherCountryCode = CommonUtils.validateMobileNumber(
      this.state.motherPhoneNumber,
      motherCountryCodeDetail
    )
    let fatherCountryCodeDetail = this.state.hashedCountryCode[
      this.state.fatherCountryCode
    ]
    let validateFatherCountryCode = CommonUtils.validateMobileNumber(
      this.state.fatherPhoneNumber,
      fatherCountryCodeDetail
    )
    if (!validateMotherCountryCode) {
      this.setState({ isInvalidMotherMobile: true })
      return false
    } else {
      this.setState({ isInvalidMotherMobile: false })
    }

    if (!validateFatherCountryCode) {
      this.setState({ isInvalidFatherMobile: true })
      return false
    } else {
      this.setState({ isInvalidFatherMobile: false })
    }

    if (!this.state.name) return false

    if (!this.state.email || this.state.isInvalidEmail) return false

    if (!this.state.schoolName) return false

    if (!this.state.address) return false

    if (!this.state.city) return false

    if (!this.state.zipCode) return false

    if (!this.state.mathsTeacherName) return false

    if (!this.state.motherName) return false

    if (!this.state.fatherName) return false

    if (!this.state.motherCountryCode || !this.state.motherCountryCode.trim())
      return false

    if (!this.state.motherPhoneNumber || !this.state.motherPhoneNumber.trim())
      return false

    if (!this.state.fatherCountryCode || !this.state.fatherCountryCode.trim())
      return false

    if (!this.state.fatherPhoneNumber || !this.state.fatherPhoneNumber.trim())
      return false

    if (!this.state.transerTo) return false

    if (!this.state.accountName) return false

    if (!this.state.bankName) return false

    if (!this.state.bankBranch) return false

    if (!this.state.bankCity) return false

    if (!this.state.ifscCode) return false

    if (!this.state.accountNumber) return false

    if (!this.state.schoolIdImage) return false

    if (!this.state.studentPicture) return false

    return true
  }

  saveClaimDetails = _ => {
    this.setState({ isSubmit: true, showError: true })
    let isValid = this.validatePayload(true)
    if (!isValid) {
      this.setState({
        isSubmit: false
      })
      return false
    }

    let hashKey = CryptoJS.AES.encrypt(
      Constants.STUDENT_FORM_FILL_SECRET_MESSAGE,
      Constants.STUDENT_FORM_FILL_SECRET_KEY
    ).toString()

    const payload = {
      discountId: this.state.discountId,
      email: this.state.email,
      name: this.state.name,
      schoolName: this.state.schoolName,
      address: this.state.address,
      city: this.state.city,
      zipCode: this.state.zipCode,
      mathsTeacherName: this.state.mathsTeacherName,
      motherName: this.state.motherName,
      fatherName: this.state.fatherName,
      motherCountryCode: this.state.motherCountryCode,
      motherPhoneNumber: this.state.motherPhoneNumber,
      fatherCountryCode: this.state.fatherCountryCode,
      fatherPhoneNumber: this.state.fatherPhoneNumber,
      transerTo: this.state.transerTo,
      accountName: this.state.accountName,
      bankName: this.state.bankName,
      bankBranch: this.state.bankBranch,
      bankCity: this.state.bankCity,
      ifscCode: this.state.ifscCode,
      accountNumber: this.state.accountNumber,
      schoolIdImage: this.state.schoolIdImage,
      studentPicture: this.state.studentPicture,
      instagramId: this.state.instagramId,
      facebookPage: this.state.facebookPage,
      transferToOthers: this.state.transferToOthers,
      hashKey
    }

    CommonApi.addClaimDetails(payload)
      .then(data => {
        this.setState({
          isSubmit: false,
          isSuccess: true
        })
      })
      .catch(err => {
        this.setState({
          isSubmit: false
        })
      })
  }

  onChangeHandler = (event, key) => {
    this.setState({ [key]: event.target.value }, _ => {
      if (key === 'email') {
        this.setState({
          isSubmit: false
        })
      }
      this.validatePayload()
    })
  }

  onImageUpload (event, key) {
    this.setState({ hideDone: true })
    let file = event.target.files[0]
    if (!file) return
    let previewImage = URL.createObjectURL(file)
    this.setState({
      [key + 'Preview']: previewImage
    })
    this.getSignedURL(file, key)
  }

  getSignedURL (file, key) {
    let payload = {
      fileName: file.name
    }
    CommonApi.getSignedUrl(payload)
      .then(response => {
        this.uploadFile(response.data.signedUrl, file, key)
      })
      .catch(error => {
        console.log(error)
      })
  }

  uploadFile = (signedUrl, file, key) => {
    let type = 'IMAGE'
    if (file.type.includes('video')) type = 'VIDEO'
    else if (file.type.includes('audio')) type = 'AUDIO'

    CommonApi.uploadFileAwsS3(signedUrl, file)
      .then(response => {
        let splittedSignedUrl = signedUrl.split('?')
        if (splittedSignedUrl && splittedSignedUrl.length) {
          this.setState({ [key]: splittedSignedUrl[0], uploadedFileType: type })
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  onSelect = (option, key) => {
    this.setState({ [key]: option?.value }, _ => {
      this.validatePayload()
      if (key === 'city' && option?.value) {
        let cityInfo = this.cityHash[option?.value]
        if (cityInfo.countryCode) {
          this.setState(
            {
              countryCode: cityInfo.countryCode
            },
            _ => {
              if (this.countryCodeDropdownRef) {
                this.countryCodeDropdownRef.clearAll()
                if (
                  this.props.hashedCountryCode &&
                  this.props.hashedCountryCode[cityInfo.countryCode]
                ) {
                  const countryCodeData = this.props.hashedCountryCode[
                    cityInfo.countryCode
                  ]
                  this.countryCodeDropdownRef.onClickOption({
                    title: `${countryCodeData.name} ${countryCodeData.dialCode}`,
                    addOn: countryCodeData.name,
                    value: countryCodeData.dialCode
                  })
                }
              }
            }
          )
        } else {
          this.setState({ countryCode: '', reloadCountryCode: true }, () => {
            this.setState({ reloadCountryCode: false })
          })
        }
      }
    })
  }

  onSelectTransferTo = option => {
    this.setState({ transerTo: option?.value })
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  render () {
    const {
      toasterMessage,
      toasterType,
      showToaster,
      isSubmit,
      showError,
      amount,
      schoolName,
      email,
      name,
      address,
      city,
      zipCode,
      mathsTeacherName,
      motherName,
      motherCountryCode,
      motherPhoneNumber,
      fatherName,
      fatherCountryCode,
      fatherPhoneNumber,
      transerTo,
      transferToOthers,
      accountName,
      accountNumber,
      ifscCode,
      bankBranch,
      bankCity,
      bankName,
      schoolIdImage,
      studentPicture,
      instagramId,
      facebookPage,
      isInvalidEmail,
      isInvalidMotherMobile,
      isInvalidFatherMobile,
      countryCodeDropDownData,
      discountError,
      studentPicturePreview,
      schoolIdImagePreview,
      isSuccess,
      discountDetails
    } = this.state

    return (
      <>
        <div className='container-fluid claim-form'>
          {/* {this.state.loading && <Loading />} */}
          <div className='row no-gutters'>
            <div className='col-12 p-2 py-3'>
              <img alt='cw-logo' src={getImageSource(ImageConstants.CW_LOGO)} />
            </div>
          </div>
          {discountError && (
            <div className='invalid-text text-center mt-5'>Invalid Link</div>
          )}
          {!discountError && !this.state.loading && !isSuccess && (
            <div className='mt-2'>
              {/* <div className='scholarship-header text-center'>
                Congratulations,{' '}
                {discountDetails && discountDetails.user
                  ? discountDetails.user.name
                  : ''}
                !
              </div> */}
              <div className='scholarship-description text-center'>
                <div>
                  The deadline for submitting your information is closed.{' '}
                </div>{' '}
                <div>
                  Please contact{' '}
                  <a href='mailto:support@countingwell.com'>
                    support@countingwell.com
                  </a>{' '}
                  for any assistance.{' '}
                </div>
              </div>
              {/* <div className='scholarship-image text-center'>
                <img
                  src={getImageSource(ImageConstants.CLAIM_SCHOLARSHIP_BANNER)}
                />
              </div>
              <div className='scholarship-form mt-4'>
                <div className='form-header text-center'>
                  Fill the form to claim you cash prize
                </div>
                <div className='cw-card mb-5'>
                  <div className='cw-card-body'>
                    <div className='row'>
                      <div className='col'>
                        <label className='cw-input-label'>EMAIL ID</label>
                        <input
                          className={`cw-input 
                                ${(isInvalidEmail && email) ||
                              (showError && !email)
                              ? 'invalid'
                              : ''
                            }`}
                          placeholder='Enter Your Email Id'
                          onChange={e => this.onChangeHandler(e, 'email')}
                          onBlur={this.onBlurEmailInput}
                          onFocus={this.onFocusEmailInput}
                          value={email}
                          disabled={this.props.isProfile}
                        />

                        {isInvalidEmail && email && (
                          <span className='invalid-text'>
                            Enter valid email
                          </span>
                        )}
                        {showError && !email && (
                          <span className='invalid-text'>
                            Please enter your email
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>FULL NAME</label>
                        <input
                          className={`cw-input 
                                ${showError && !name ? 'invalid' : ''}`}
                          placeholder='Enter Your Full Name'
                          onChange={e => this.onChangeHandler(e, 'name')}
                          value={name}
                        />
                        {showError && !name && (
                          <span className='invalid-text'>
                            Please enter your full name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>SCHOOL NAME</label>
                        <input
                          className={`cw-input  text-area
                                ${showError && !schoolName ? 'invalid' : ''}`}
                          placeholder='Enter Your School Name'
                          onChange={e => this.onChangeHandler(e, 'schoolName')}
                          value={schoolName}
                        />
                        {showError && !schoolName && (
                          <span className='invalid-text'>
                            Please enter your school name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          COMPLETE POSTAL ADDRESS
                        </label>
                        <textarea
                          className={`cw-input 
                                ${showError && !address ? 'invalid' : ''}`}
                          placeholder='Enter Your Address'
                          onChange={e => this.onChangeHandler(e, 'address')}
                          value={address}
                        ></textarea>
                        {showError && !address && (
                          <span className='invalid-text'>
                            Please enter your address
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>CITY</label>
                        <input
                          className={`cw-input 
                                ${showError && !city ? 'invalid' : ''}`}
                          placeholder='Enter Your City'
                          onChange={e => this.onChangeHandler(e, 'city')}
                          value={city}
                        />
                        {showError && !city && (
                          <span className='invalid-text'>
                            Please enter your city
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>PIN</label>
                        <input
                          className={`cw-input 
                                ${showError && !zipCode ? 'invalid' : ''}`}
                          placeholder='Enter Your Pin Code'
                          onChange={e => this.onChangeHandler(e, 'zipCode')}
                          value={zipCode}
                        />
                        {showError && !zipCode && (
                          <span className='invalid-text'>
                            Please enter your pin code
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          MATHS TEACHER’S NAME
                        </label>
                        <input
                          className={`cw-input 
                                ${showError && !mathsTeacherName
                              ? 'invalid'
                              : ''
                            }`}
                          placeholder='Enter Your Maths Teacher Name'
                          onChange={e =>
                            this.onChangeHandler(e, 'mathsTeacherName')
                          }
                          value={mathsTeacherName}
                        />
                        {showError && !mathsTeacherName && (
                          <span className='invalid-text'>
                            Please enter your maths teacher name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>MOTHER’S NAME</label>
                        <input
                          className={`cw-input 
                                ${showError && !motherName ? 'invalid' : ''}`}
                          placeholder='Enter Your Mother Name'
                          onChange={e => this.onChangeHandler(e, 'motherName')}
                          value={motherName}
                        />
                        {showError && !motherName && (
                          <span className='invalid-text'>
                            Please enter your mother name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>MOTHER'S PHONE</label>
                      </div>
                    </div>
                    <div className='row phone-number-container'>
                      <div
                        className='d-inline-block mr-2'
                        style={{ width: '25%' }}
                      >
                        {countryCodeDropDownData &&
                          countryCodeDropDownData.length &&
                          !this.state.reloadCountryCode ? (
                          <Dropdown
                            key='countryCode'
                            text='title'
                            placeholder='Select country code'
                            searchable
                            options={countryCodeDropDownData}
                            invalid={showError && !motherCountryCode}
                            onSelect={option =>
                              this.onSelect(option, 'motherCountryCode')
                            }
                            value={motherCountryCode ? motherCountryCode : ''}
                            allOptions={countryCodeDropDownData}
                            onSearch={value => this.onCountryCodeSearch(value)}
                            style={{ background: '#F6F7F5' }}
                            ref={ref => (this.countryCodeDropdownRef = ref)}
                          />
                        ) : (
                          ''
                        )}
                      </div>
                      <div className='d-inline-block' style={{ width: '70%' }}>
                        <input
                          className={`cw-input 
                      ${(isInvalidMotherMobile && motherPhoneNumber) ||
                              (showError && !motherPhoneNumber)
                              ? 'invalid'
                              : ''
                            }`}
                          placeholder="Enter Your mother's phone number"
                          onChange={e =>
                            this.onChangeHandler(e, 'motherPhoneNumber')
                          }
                          value={motherPhoneNumber}
                        />
                      </div>
                      <div className='col'>
                        {showError && !motherPhoneNumber && (
                          <span className='invalid-text'>
                            Please enter mother's phone number
                          </span>
                        )}
                        {isInvalidMotherMobile && motherPhoneNumber && (
                          <span className='invalid-text'>
                            Enter valid phone number
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>FATHER'S NAME</label>
                        <input
                          className={`cw-input 
                                ${showError && !fatherName ? 'invalid' : ''}`}
                          placeholder="Enter Your Father's Name"
                          onChange={e => this.onChangeHandler(e, 'fatherName')}
                          value={fatherName}
                        />
                        {showError && !fatherName && (
                          <span className='invalid-text'>
                            Please enter your father's name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>FATHER'S PHONE</label>
                      </div>
                    </div>
                    <div className='row phone-number-container'>
                      <div
                        className='d-inline-block mr-2'
                        style={{ width: '25%' }}
                      >
                        {countryCodeDropDownData &&
                          countryCodeDropDownData.length &&
                          !this.state.reloadCountryCode ? (
                          <Dropdown
                            key='countryCode'
                            text='title'
                            placeholder='Select country code'
                            searchable
                            options={countryCodeDropDownData}
                            invalid={showError && !fatherCountryCode}
                            onSelect={option =>
                              this.onSelect(option, 'fatherCountryCode')
                            }
                            value={fatherCountryCode ? fatherCountryCode : ''}
                            allOptions={countryCodeDropDownData}
                            onSearch={value => this.onCountryCodeSearch(value)}
                            style={{ background: '#F6F7F5' }}
                            ref={ref => (this.countryCodeDropdownRef = ref)}
                          />
                        ) : (
                          ''
                        )}
                      </div>
                      <div className='d-inline-block' style={{ width: '70%' }}>
                        <input
                          className={`cw-input 
                      ${(isInvalidFatherMobile && fatherPhoneNumber) ||
                              (showError && !fatherPhoneNumber)
                              ? 'invalid'
                              : ''
                            }`}
                          placeholder="Enter Your father's phone number"
                          onChange={e =>
                            this.onChangeHandler(e, 'fatherPhoneNumber')
                          }
                          value={fatherPhoneNumber}
                        />
                      </div>
                      <div className='col'>
                        {showError && !fatherPhoneNumber && (
                          <span className='invalid-text'>
                            Please enter father's phone number
                          </span>
                        )}
                        {isInvalidFatherMobile && fatherPhoneNumber && (
                          <span className='invalid-text'>
                            Enter valid phone number
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          WHOSE BANK ACCOUNT SHOULD BE TRANSFER THE SCHOLARSHIP
                          AMOUNT TO
                        </label>
                        <Dropdown
                          text='title'
                          ref={instance => {
                            this.dropdown = instance
                          }}
                          placeholder='Select'
                          options={transferToData}
                          invalid={showError && !transerTo}
                          onSelect={option => this.onSelectTransferTo(option)}
                          value={transerTo}
                          style={{ background: '#F6F7F5' }}
                        />
                        {showError && !transerTo && (
                          <span className='invalid-text'>
                            Please select one of the options
                          </span>
                        )}
                      </div>
                    </div>
                    {transerTo === 'Others' && (
                      <div className='row bw-spaces-input'>
                        <div className='col'>
                          <label className='cw-input-label'>
                            Others (Specify)
                          </label>
                          <input
                            className={`cw-input`}
                            placeholder=''
                            onChange={e =>
                              this.onChangeHandler(e, 'transferToOthers')
                            }
                            value={transferToOthers}
                          />
                          {showError && !transferToOthers && (
                            <span className='invalid-text'>
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          Full Name on the Bank Account
                        </label>
                        <input
                          className={`cw-input 
                                ${showError && !accountName ? 'invalid' : ''}`}
                          placeholder='Enter Name On Bank Account'
                          onChange={e => this.onChangeHandler(e, 'accountName')}
                          value={accountName}
                        />
                        {showError && !accountName && (
                          <span className='invalid-text'>
                            Please enter name on bank account
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>Bank Name</label>
                        <input
                          className={`cw-input 
                                ${showError && !bankName ? 'invalid' : ''}`}
                          placeholder='Enter Bank Name'
                          onChange={e => this.onChangeHandler(e, 'bankName')}
                          value={bankName}
                        />
                        {showError && !bankName && (
                          <span className='invalid-text'>
                            Please enter bank name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>Bank Branch</label>
                        <input
                          className={`cw-input 
                                ${showError && !bankBranch ? 'invalid' : ''}`}
                          placeholder='Enter Bank Branch'
                          onChange={e => this.onChangeHandler(e, 'bankBranch')}
                          value={bankBranch}
                        />
                        {showError && !bankBranch && (
                          <span className='invalid-text'>
                            Please enter bank branch
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>Bank City</label>
                        <input
                          className={`cw-input 
                                ${showError && !bankCity ? 'invalid' : ''}`}
                          placeholder='Enter Bank City'
                          onChange={e => this.onChangeHandler(e, 'bankCity')}
                          value={bankCity}
                        />
                        {showError && !bankCity && (
                          <span className='invalid-text'>
                            Please enter bank city
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>IFSC Code</label>
                        <input
                          className={`cw-input 
                                ${showError && !ifscCode ? 'invalid' : ''}`}
                          placeholder='Enter IFSC Code'
                          onChange={e => this.onChangeHandler(e, 'ifscCode')}
                          value={ifscCode}
                        />
                        {showError && !ifscCode && (
                          <span className='invalid-text'>
                            Please enter IFSC code
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          Bank Account Number
                        </label>
                        <input
                          className={`cw-input 
                                ${showError && !accountNumber ? 'invalid' : ''
                            }`}
                          placeholder='Enter Bank Account Number'
                          onChange={e =>
                            this.onChangeHandler(e, 'accountNumber')
                          }
                          value={accountNumber}
                        />
                        {showError && !accountNumber && (
                          <span className='invalid-text'>
                            Please enter bank account name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          UPLOAD A PIC OF YOUR SCHOOL ID
                        </label>
                        <div>
                          <label
                            className='m-0 ml-1 cursor-pointer'
                            style={{ cursor: 'pointer' }}
                          >
                            <input
                              type='file'
                              style={{ display: 'none' }}
                              accept={this.props.accept || ''}
                              onChange={event =>
                                this.onImageUpload(event, 'schoolIdImage')
                              }
                            />
                            <span className='upload-pic cursor-pointer'>
                              <FontAwesomeIcon icon={faPlus} color='#979393' />
                            </span>
                          </label>
                          {schoolIdImagePreview && (
                            <div className='preview-img'>
                              <img src={schoolIdImagePreview}></img>
                            </div>
                          )}
                        </div>
                        {showError && !schoolIdImage && (
                          <span className='invalid-text'>
                            Please upload a picture
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          UPLOAD A FUN PICTURE OF YOU
                        </label>
                        <div>
                          <label
                            className='m-0 ml-1 cursor-pointer'
                            style={{ cursor: 'pointer' }}
                          >
                            <input
                              type='file'
                              style={{ display: 'none' }}
                              accept={this.props.accept || ''}
                              onChange={event =>
                                this.onImageUpload(event, 'studentPicture')
                              }
                            />
                            <span className='upload-pic cursor-pointer'>
                              <FontAwesomeIcon icon={faPlus} color='#979393' />
                            </span>
                          </label>
                          {studentPicturePreview && (
                            <div className='preview-img'>
                              <img src={studentPicturePreview}></img>
                            </div>
                          )}
                        </div>
                        {showError && !studentPicture && (
                          <span className='invalid-text'>
                            Please upload a picture
                          </span>
                        )}
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          YOUR INSTAGRAM ID
                        </label>
                        <input
                          className={`cw-input`}
                          placeholder='Enter Your Instragram ID'
                          onChange={e => this.onChangeHandler(e, 'instagramId')}
                          value={instagramId}
                        />
                      </div>
                    </div>
                    <div className='row bw-spaces-input'>
                      <div className='col'>
                        <label className='cw-input-label'>
                          Your FACEBOOK PAGE
                        </label>
                        <input
                          className={`cw-input`}
                          placeholder='Enter Your Facebook page'
                          onChange={e =>
                            this.onChangeHandler(e, 'facebookPage')
                          }
                          value={facebookPage}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`cw-card-footer ${this.state.isValidForm ? '' : 'gray-footer'
                      }`}
                    onClick={!isSubmit && this.saveClaimDetails}
                  >
                    <span className='footer-text '>Register</span>
                  </div>
                </div>
              </div> */}
            </div>
          )}
          {!discountError && !this.state.loading && isSuccess && (
            <div className='mt-2 scholarship-form'>
              <div className='scholarship-header text-center'>Thank you</div>
              <div className='scholarship-description text-center'>
                Your scholarship amount will be remitted to your bank on or
                before 15 June. It will be remitted to the following details:
              </div>
              <div className='cw-card mb-5'>
                <div className='cw-card-body'>
                  <div className='student-details'>
                    <div>
                      <strong>Full Name of A/C Holder:</strong> {accountName}
                    </div>
                    <div>
                      <strong>Bank Name:</strong> {bankName}
                    </div>
                    <div>
                      <strong>Branch:</strong> {bankBranch}
                    </div>
                    <div>
                      <strong>City:</strong> {bankCity}
                    </div>
                    <div>
                      <strong>IFSC code:</strong> {ifscCode}
                    </div>
                    <div>
                      <strong>Account No:</strong> {accountNumber}
                    </div>
                  </div>
                  <div className='separator'></div>
                  <div className='form-header'>
                    You can use Countingwell Further to
                  </div>
                  <ul className='scholarship-description'>
                    <li>Learn and Practice Maths and Improve your scores</li>
                    <li>
                      Take up courses like Financial Literacy and Data Science
                    </li>
                    <li>
                      Participate in more competitions. The next competition is
                      Monthly Maths Marathon and it has already started
                    </li>
                  </ul>
                  <div className='separator'></div>
                  <div>
                    <img src={getImageSource(ImageConstants.GIFTBOX)} />
                  </div>
                  <div className='mt-3 scholarship-description'>
                    You have also won a{' '}
                    <strong>
                      {discountDetails && discountDetails.discount
                        ? discountDetails.discount.value
                        : 0}
                      % scholarship discount
                    </strong>{' '}
                    to the Annual Countingwell Learning Plan which allows you
                    uninterrupted access to your school syllabus learning on the
                    Countingwell App for 365 days.
                  </div>
                  <div
                    className={`cw-card-footer`}
                    onClick={_ => {
                      !isSubmit &&
                        window.open(
                          'https://countingwell.com/scholarship/subscription?id=' +
                            this.state.discountId
                        )
                    }}
                  >
                    <span className='footer-text'>CLAIM YOUR SCHOLARSHIP</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {showToaster ? (
          <ToasterComponent
            message={toasterMessage}
            type={toasterType}
            position='bottom-center'
          />
        ) : (
          ''
        )}
      </>
    )
  }
}

export default ClaimForm
